// PlaceholderSlide — used for role-specific middle steps not yet implemented.
//
// The wizard has a complete role-aware step list per audit doc 19 §3, but
// individual middle steps (client-address, worker-skills, company-services,
// etc.) are scheduled in follow-up sessions. Until they ship, this generic
// slide explains what would normally happen and offers Skip → Continue.
//
// When a real slide ships, swap out the entry in OnboardingOrchestrator's
// SLIDE_MAP.

import { useOnboarding } from '../useOnboarding'
import SlideShell from './SlideShell'

interface Props {
  progress: number
  onBack: () => void
  title: string
  body: string
}

export default function PlaceholderSlide({ progress, onBack, title, body }: Props) {
  const { next, skip } = useOnboarding()

  return (
    <SlideShell
      progress={progress}
      onBack={onBack}
      onSkip={skip}
      footer={
        <button
          onClick={next}
          className="w-full bg-blue-600 active:bg-blue-700 active:scale-[0.99] transition text-white text-base font-medium px-4 py-3.5 rounded-xl"
        >
          Continuă
        </button>
      }
    >
      <div className="flex flex-col items-center text-center pt-16">
        <div className="w-16 h-16 rounded-2xl bg-gray-100 flex items-center justify-center mb-6" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4" />
            <path d="M12 16h.01" />
          </svg>
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          {title}
        </h1>
        <p className="text-base text-gray-600 dark:text-gray-300 mt-4 max-w-sm">
          {body}
        </p>
        <p className="text-xs text-gray-400 mt-8">
          Poți completa asta și mai târziu din setări.
        </p>
      </div>
    </SlideShell>
  )
}
